import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
//import {AlertProvider} from 'react-native-async-alert';
//import {useShowAlert} from 'react-native-async-alert';
import { useNavigate } from 'react-router-dom'

//var dateFormat = require('dateformat');



const Rendervsaform = () => {


const resturl=sessionStorage.getItem("RESTURL");
const navvsaapps = React.useRef();

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [tblwpfverify, setTblwpfverify] = useState([]);
const [renders, setRenders] = useState({count:0});
const [vsaapp, setVsaapp] = useState({VSA_APP_ID:0});
const [dowait, setDowait] = useState({show: false});

const [TOTAL_EMPTY_FIELDS, setTOTAL_EMPTY_FIELDS] = useState({NUM:500});




const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "APS Summary";	

if (location.state.VSA_APP_ID!=null && location.state.VSA_APP_ID!=undefined && location.state.VSA_APP_ID!='null' && location.state.VSA_APP_ID!='undefined'){
	setVsaapp({VSA_APP_ID:location.state.VSA_APP_ID});
	}//end if
else
	console.log("location.state.VSA_APP_ID not provided");
	//qrylabor();
 },[]);

useEffect(() => {
//console.log("useEffect"+vsaapp.VSA_APP_ID);
if (vsaapp.VSA_APP_ID>0){
	console.log('vsaapp.APP_TYPE_ID'+vsaapp.APP_TYPE_ID)
	if (vsaapp.REF_NUM==undefined)
		getvsaapp();
	else if (tblwpfverify.length<1)
		gettblvsaverify();
	}//end if
 },[vsaapp]);


function gettblvsaverify(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VSA_APP_ID:vsaapp.VSA_APP_ID} )
  };		

  fetch(resturl+'rarvsaform/gettblvsaverify',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblvsaverify(res) )
      .catch(err => console.log(err));

}//end func



function aftergettblvsaverify(res){
if (res.length==undefined)
	return;
	
console.log('aftergettblvsaverify, res.length: '+res.length);

let htmrows=[];
res.map((col, index) => {
	if (index==1)
		setTOTAL_EMPTY_FIELDS({NUM:col['TOTAL_EMPTY_FIELDS']});


});

}//end func

function getvsaapp(e){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VSA_APP_ID:vsaapp.VSA_APP_ID} )
  };		

  fetch(resturl+'rarvsaform/getvsaapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetvsaapp(res) )
      .catch(err => console.log(err));

}//end func

function aftergetvsaapp(res){
	setVsaapp(res[0]);
	console.log('aftergetvsaapp: '+res[0].OCCUPATION);
}//end func



function submitvsaapp(e){
	
	if (TOTAL_EMPTY_FIELDS.NUM>0){
		showsnackbar(TOTAL_EMPTY_FIELDS.NUM+' mandatory fields remain to be populated');
		return;
		}//end if
		setDowait({show:true});
	
//	e.preventDefault();

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VSA_APP_ID:vsaapp.VSA_APP_ID} )
  };		

  fetch(resturl+'rarvsaform/submitvsaapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersubmitvsaapp(res) )
      .catch(err => console.log(err));

//return false;

}//end func

function aftersubmitvsaapp(res){
	
	setDowait({show:false});
	toggleModalsm();//alert('applcation has been submitted')
	
	
//	console.log('res.myhref: '+res.myhref);
//window.open(res.myhref);

}//end func

function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".trigger"))
	document.querySelector(".trigger").addEventListener("click", toggleModalsm);

if (document.querySelector(".close-button"))
	document.querySelector(".close-button").addEventListener("click", toggleModalsm);

window.addEventListener("click", windowOnClick);
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");	
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func


async function openScans (e) {
e.preventDefault();
//const fileName=;
const coverfilepath=vsaapp.REF_NUM+"/scans.pdf";

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {filepath:coverfilepath} )
  };

//rarwpform/getwptappfoto
  fetch(resturl+'rarwpform/getwptappfile',requestOptions)
      .then(res => afteropenScans(res, vsaapp.REF_NUM+"_scans.pdf"))
      .catch(err => console.log(err));


}//end func

async function afteropenScans(res, fileName){
console.log('afteropenScans');
const blob = await res.blob()
const data = window.URL.createObjectURL(new Blob([blob]))

const link = document.createElement("a");
link.href = data;
link.setAttribute("download", fileName);
document.body.appendChild(link);
link.click();
//link.parentNode!.removeChild(link);	
link.parentNode?.removeChild(link);	
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


const refnum=vsaapp.REF_NUM;
const refurl=sessionStorage.getItem("UPLOADURL")+refnum+"/";
console.log('refurl: '+refurl);


	
  return (
    <>
	<p align='center' style={{marginBottom:"0px"}}>
	Visa application {refnum} summary review and submit to Customer Service Center
	</p>
	{/* <span style={{width:"200px",backgroundColor:"green"}}>appe</span> */}
	<table align='center' >
	<tbody>
	<tr  key="tr_STEP1" >
	<td align='left' colSpan="3" >
	<ul>
		<li>step 1: <a href="#" onClick={(e)=>{openScans(e);}} target="_none" className="nodecor" >click here</a> to see scanned documents</li>
		<li>step 2: verify whether or not the information below is correct</li>
		<li>step 3: if the information is correct then click the submit button</li>
	</ul>
	</td>
	</tr>
	<tr  key="tr_MPE_CTRY" >
	<td align='right' >Country of Birth: </td>
	<td align='left' >{vsaapp.VSR_COB}</td>
	</tr>
	<tr  key="tr_MPE_DOB" >
	<td align='right' >Date of Birth: </td>
	<td align='left' >{vsaapp.CHR_VSR_DOB}</td>
	</tr>
	<tr  key="tr_MPE_PASSPORT_CTY" >
	<td align='right' >Passport Country of Issue: </td>
	<td align='left' >{vsaapp.CURR_PSP_CTY}</td>
	</tr>
	
	<tr  key="tr_MPE_PPT" >
	<td align='right' >Passport Number: </td>
	<td align='left' >{vsaapp.CURR_PSP_NBR}</td>
	<td align='center' rowSpan="6" >
		{vsaapp.REF_NUM!=undefined &&
		<img src={resturl+"rarwpform/getwptappfoto?path="+vsaapp.REF_NUM+"/foto.png"} border='0' height="150" />
		}	
	</td>
	</tr>

	<tr  key="tr_MPR_NAME" >
	<td align='right' >Surety: </td>
	<td align='left' >{vsaapp.STY_GVN_NAM+" "+vsaapp.STY_SUR_NAM}</td>
	</tr>
	<tr key="tr_MPE_FIRST_NAME" >
	<td align='right' >Applicant: </td>
	<td align='left' >{vsaapp.VSR_GVN_NAM+" "+vsaapp.VSR_SUR_NAM}</td>
	</tr>
	<tr key="tr_OCCUPATION" >
	<td align='right' >Visa Type: </td>
	<td align='left' >{vsaapp.VSA_TYP}</td>
	</tr>


	{/*
	<tr key="tr_WAGES" >
	<td align='right' >Salary: </td>
	<td align='left' >{"$ "+vsaapp.MPE_SALARY_AMT+" "+vsaapp.MPE_SALARY_PRD}</td>
	</tr>
	<tr key="tr_WRK_CONTRACT" >
	<td align='right' >Contract Dates: </td>
	<td align='left' >{vsaapp.CHR_WRK_CONTRACT_START+" to "+vsaapp.CHR_WRK_CONTRACT_END}</td>
	</tr>
	<tr key="tr_MED_CERT" >
	<td align='right' >Migrant Health Certificate Dates: </td>
	<td align='left' >{vsaapp.CHR_MED_CERT_ISSUE_DATE+" to "+vsaapp.CHR_MED_CERT_EXPIRE_DATE}</td>
	</tr>
	<tr key="key_tr_LOCATION_ID" >
	<td align='right' >Location:</td>
	<td align='left' ><select key="input_LOCATION_ID" name='LOCATION_ID' defaultValue={vsaapp.LOCATION_ID}   ><option defaultValue='' ></option>{locations}</select></td>
	</tr>
	
	*/}	
	</tbody>
	</table>
	
	
	
	

<p align='center' >  
        <NavLink
          to={"/vsaform"}
          state={{
		  VSA_APP_ID:vsaapp.VSA_APP_ID
		  }} 
		
        >return to application form</NavLink>
		&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
		
		{dowait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
		{
		!dowait.show && 
		<input type="button" id='btnsubmitapp' className="button" value="submit application to Customer Service Center" onClick={(e)=>{ submitvsaapp(e); }}  />
		}
</p>  

	<div id="snackbar">&nbsp;</div>

	<div className="modalsm">
		<div className="modalsm-content">
			<span className="close-button">&times;</span>
			<div align='center' id='modalsmtext' >
			<img src='img/greentick.png' border='0' height='48' /> your application is submitted!
			<p>you should receive email after it is processed</p>			
			<p><button className="button" style={{width:"120px"}} onClick={(e)=>{navigate('/vsaapps',{state:{VSA_APP_ID:vsaapp.VSA_APP_ID}});}} >Ok</button></p>
			
				{/*
			<NavLink ref={navvsaapps} to={"/vsaapps"} 
			  state={{VSA_APP_ID:vsaapp.VSA_APP_ID}}  >Ok</NavLink>
				
				*/}
			</div>
		</div>
	</div>

    </>
  );
  


};


export default Rendervsaform;